import { render, staticRenderFns } from "./articleMarket.vue?vue&type=template&id=454796be&scoped=true&"
import script from "./articleMarket.vue?vue&type=script&lang=js&"
export * from "./articleMarket.vue?vue&type=script&lang=js&"
import style0 from "./articleMarket.vue?vue&type=style&index=0&id=454796be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454796be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454796be')) {
      api.createRecord('454796be', component.options)
    } else {
      api.reload('454796be', component.options)
    }
    module.hot.accept("./articleMarket.vue?vue&type=template&id=454796be&scoped=true&", function () {
      api.rerender('454796be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/articleMarket/articleMarket.vue"
export default component.exports